import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class InsuranceQuoteDatesController extends Controller {
  static targets = ['departureDate', 'returnDate']

  returnTouched = false

  // Default the Return Date to the Departure Date, until the traveller picks a
  // Return Date of their own.
  // setDate only updates the value, so gotoDate is needed to move the calendar
  // off whichever month the Return Date was seeded with.
  mirrorDeparture () {
    if (this.returnTouched) return

    const departure = this.departureDateTarget.value
    const picker = this.#returnPicker()
    if (!departure || !picker) return

    picker.gotoDate(departure)
    picker.setDate(departure)
  }

  markReturnTouched () {
    this.returnTouched = true
  }

  #returnPicker () {
    return this.application.getControllerForElementAndIdentifier(this.returnDateTarget, 'easepick')?.picker
  }
}

stimulus.register('insurance-quote-dates', InsuranceQuoteDatesController)
